export const BASE_URL = 'https://opportrade.com';
